import { createAction } from 'Utility/Redux';
import { SeasonPassRewardType } from 'Types/State/Player/SeasonPass';
import { SeasonPassTractorProgress } from 'Types/SeasonPass';

enum Types {
    claimRankReward = 'SP_claimRankReward',
    addSeasonPassProgress = 'SP_addSeasonPassProgress',
    setSeasonPassProgress = 'SP_setSeasonPassProgress',
    setSeasonPassLastSeenProgress = 'SP_setSeasonPassLastSeenProgress',
    resetSeasonPass = 'SP_resetSeasonPass',
    checkSeasonPassUnlocked = 'SP_checkSeasonPassUnlocked',
}

export interface ISeasonPassClaimRankRewardPayload {
    rank: number;
    type: SeasonPassRewardType;
}

export const SeasonPassActions = {
    claimRankReward: createAction(Types.claimRankReward, resolve => (rank: number, type: SeasonPassRewardType) =>
        resolve<ISeasonPassClaimRankRewardPayload>({ rank, type })
    ),
    addSeasonPassProgress: createAction(Types.addSeasonPassProgress, resolve => (amount: number) =>
        resolve<number>(amount)
    ),
    setSeasonPassProgress: createAction(Types.setSeasonPassProgress, resolve => (amount: number) =>
        resolve<number>(amount)
    ),
    setSeasonPassLastSeenProgress: createAction(
        Types.setSeasonPassLastSeenProgress,
        resolve => (value: SeasonPassTractorProgress) => resolve<SeasonPassTractorProgress>(value)
    ),
    resetSeasonPass: createAction(Types.resetSeasonPass, resolve => (unlockPremium = false) =>
        resolve<boolean>(unlockPremium)
    ),
    checkSeasonPassUnlocked: createAction(Types.checkSeasonPassUnlocked),
};
